<template>
  <ModalComponent
    :model-value="showRef"
    :close="handleCloseModal"
    :max-width="38"
    :style-class-contain="styleClassContain"
  >
    <ModalHeader
      :is-header="`no__header`"
      style="z-index: 10"
      title=""
      @close="handleCloseModal"
    />
    <div class="tw-pt-0 tw-p-10 tw-flex tw-flex-col">
      <div class="tw-text-[25px] tw-flex tw-flex-col tw-gap-[10px]">
        <div
          class="tw-font-semibold tw-text-[#211F58] tw-leading-[normal] tw-mb-[15px]"
        >
          {{ title }}
        </div>
      </div>
      <div
        class="tw-text-[15px] tw-flex tw-flex-col tw-gap-[20px] tw-text-[#231F20]"
      >
        <div>
          {{
            getComponentUiText(
              "app-menu-submenu-settings-setup-wizard-modal-webfacing-not-belong-to-domain-description-1",
            )
          }}
        </div>
        <div>
          <div v-for="item in listDomains" :key="item" class="tw-flex">
            <div
              class="tw-w-[3px] tw-h-[3px] tw-bg-[#231F20] tw-rounded-[100%] tw-m-[9.3px]"
            />
            <div class="tw-flex-1">
              {{ item }}
            </div>
          </div>
        </div>
        <div>
          {{
            listDomains && listDomains.length > 1
              ? getComponentUiText(
                  "app-menu-submenu-settings-setup-wizard-modal-webfacing-not-belong-to-domains-sub-description-1",
                )
              : getComponentUiText(
                  "app-menu-submenu-settings-setup-wizard-modal-webfacing-not-belong-to-domain-sub-description-1",
                )
          }}
        </div>
      </div>
      <div class="tw-flex tw-justify-end tw-mt-10">
        <div>
          <button
            class="tw-border-[#F7553C] tw-mr-[15px] tw-bg-[#F7553C] hover:!tw-bg-[#c82333] tw-py-[12px] tw-px-[18px] tw-text-[15px] tw-rounded-[27px] tw-h-[39px] tw-leading-[100%] tw-font-medium"
            :class="['tw-text-white']"
            @click="handleUpdateModal(false)"
          >
            {{
              getComponentUiText(
                "app-menu-submenu-home-setup-wizard-radio-button-title-no-1",
              )
            }}
          </button>
        </div>
        <b-button
          style="line-height: 90%; border: 2px solid #387dff; height: 39px"
          variant="primary"
          class="tw-w-fit tw-mr-[15px] tw-shadow-none tw-py-[12px] tw-px-[18px] tw-text-[15px] tw-font-medium tw-rounded-[27px]"
          type="submit"
          @click="handleUpdateModal(true)"
        >
          {{
            getComponentUiText(
              "app-menu-submenu-home-setup-wizard-radio-button-title-yes-1",
            )
          }}
        </b-button>
      </div>
    </div>
  </ModalComponent>
</template>

<script setup lang="ts">
import ModalHeader from "../../components/common/modalHeader.vue";
import { getComponentUiText } from "../../utils/utilities";
import { ref, watch } from "vue";
import ModalComponent from "../../components/common/modalComponent.vue";

const props = defineProps({
  listDomains: {
    type: Array as () => Array<any>,
    required: true,
  },
  show: {
    type: Boolean,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
});

let showRef = ref(props.show);

watch(
  () => props.show,
  (value) => {
    showRef.value = value;
  },
);

const emit = defineEmits([
  "update:show",
  "update:domain-data",
  "update:domain-close",
]);
const handleCloseModal = () => {
  emit("update:domain-close");
  showRef.value = false;
  emit("update:show", showRef.value);
};

const handleUpdateModal = (isAdd) => {
  showRef.value = false;
  emit("update:show", showRef.value);
  emit("update:domain-data", isAdd);
};

const styleClassContain = {
  "border-radius": "4px",
  "box-shadow": "0px 0px 4px 0px rgba(0, 0, 0, 0.05)",
  overflow: "unset",
};
</script>

<style lang="scss" scoped>
.assessment-modal {
  .button-verify.btn.btn-primary[disabled] {
    background-color: red;
    color: #b7b7b7;
    border-color: #dbdbdb;
  }

  .button-verify {
    line-height: 100%;
    background-color: #387dff;
    border-color: #387dff;
  }
}

@media (max-width: 768px) {
  .assessment-modal {
    .modal-assessment,
    .modal-header {
      padding-right: 10px;
      padding-left: 10px;
    }
  }
}
</style>
